import styled from "styled-components";


export const LoyaltyPage = styled.div`
background: #fff;
& img{
    max-width: 100%;
    margin-top: 15px;
    margin-bottom: 15px;
}
`
